export default function PHP_ftp_pwd() {
  return (
    <div>
      <h1>PHP_ftp_pwd</h1>
    </div>
  );
}
